import './b24-form.scss'
import { useEffect } from 'react'

import { createScript } from '@/shared/lib/utils/script/create-script'

type B24FormProps = {
	source: string
	dataB24Form: string
}

/**
 * Contact form from bitrix24
 */
export const B24Form = ({ source, dataB24Form }: B24FormProps): JSX.Element => {
	useEffect(() => {
		const b24FormScript = createScript(source, true)

		document.head.appendChild(b24FormScript)

		return () => {
			document.head.removeChild(b24FormScript)
		}
	}, [])

	return (
		<div id="b24-form">
			<script data-b24-form={dataB24Form} />
		</div>
	)
}
